import { useCallback, useEffect, useState } from "react";

import Script from "next/script";

import { useOpenModal } from "@/components/modal/utils/openModal";

import { useFacebookLogin } from "./useFacebookLogin";

declare global {
  interface Window {
    FB: TODO;
  }
}

export const useFacebookInit = () => {
  const [sdkLoaded, setSdkLoaded] = useState(false);
  const [FBinitialized, setFBInitialized] = useState(false);

  const { openModal } = useOpenModal();

  const openInfoModal = useCallback(
    (msg: string) => {
      openModal("INFORMATION_MODAL", {
        message: msg,
        statusReg: "fail",
      });
    },
    [openModal],
  );

  useEffect(() => {
    if (!sdkLoaded) return;

    window.FB.init({
      appId: "1106631756067829",
      cookie: true,
      xfbml: true,
      version: "v19.0",
    });

    setFBInitialized(true);
  }, [sdkLoaded]);

  const renderScripts = useCallback(() => {
    return (
      <>
        <Script
          async
          defer
          crossOrigin="anonymous"
          src="https://connect.facebook.net/en_US/sdk.js"
          onLoad={() => setSdkLoaded(true)}
          onReady={() => setSdkLoaded(true)}
        />
      </>
    );
  }, []);

  const getLoginStatus = useCallback(async (): Promise<TODO> => {
    if (!FBinitialized) return;

    return new Promise((rs, _rj) => {
      window.FB.getLoginStatus(function (response: TODO) {
        rs(response);
      });
    });
  }, [FBinitialized]);

  const { mutate: facebookLogin } = useFacebookLogin();

  const openFbModal = useCallback(async () => {
    const response = await getLoginStatus();

    if (response.status === "connected") {
      facebookLogin({
        signedRequest: response.authResponse.signedRequest,
        accessToken: response.authResponse.accessToken,
      });
    } else {
      try {
        window.FB.login(function (response: TODO) {
          if (response.authResponse) {
            facebookLogin({
              signedRequest: response.authResponse.signedRequest,
              accessToken: response.authResponse.accessToken,
            });
          }
        });
      } catch (e) {
        const errMgs = typeof e === "string" ? e : "Error with facebook login";
        openInfoModal(errMgs);
      }
    }
  }, [facebookLogin, getLoginStatus, openInfoModal]);

  return { renderScripts, openFbModal };
};
